import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { BrowserRouter, Link, Route, Router, Routes } from "react-router-dom";
import Work1 from "./pages/Work1";
import Home from "./pages/Home";
import { HeaderNavigationProvider } from "./context/HeaderNavigationContext";
import Work2 from "./pages/Work2";
import Work3 from "./pages/Work3";
import Work4 from "./pages/Work4";
import Work5 from "./pages/Work5";
import Work6 from "./pages/Work6";

function App() {
  return (
    <>
      <BrowserRouter>
        <HeaderNavigationProvider>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/work1" element={<Work1 />} />
            <Route path="/work2" element={<Work2 />} />
            <Route path="/work3" element={<Work3 />} />
            <Route path="/work4" element={<Work4 />} />
            <Route path="/work5" element={<Work5 />} />
            <Route path="/work6" element={<Work6 />} />
          </Routes>
          <Footer />
        </HeaderNavigationProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
